const courtWidth = 6.10;
const courtHeight = 13.4;
const rightAngle = 1.5708;
const courtSpacing = 12.5;

export {courtWidth, courtHeight, rightAngle, courtSpacing};
